import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function PageHero({ chapter, eyebrow, title, italic, intro, accent = "sage", image, imagePosition = "center", tone = "sage" }) {
  const bg = {
    sage: "bg-sage-50",
    clay: "bg-clay-50",
    honey: "bg-honey-50",
  };
  const label = {
    sage: "text-sage-600",
    clay: "text-clay-500",
    honey: "text-honey-600",
  };
  const dash = {
    sage: "bg-sage-400",
    clay: "bg-clay-400",
    honey: "bg-honey-400",
  };
  return (
    <section className={`relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden ${bg[tone]}`}>
      <div aria-hidden className={`absolute -top-20 -left-20 w-[380px] h-[380px] rounded-full ${dash[tone]}/30 blur-3xl`} />
      <div aria-hidden className="absolute -bottom-24 right-0 w-[320px] h-[320px] rounded-full bg-honey-200/40 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <nav className="flex items-center gap-2 font-mono-fine text-[11px] tracking-[0.2em] uppercase text-ink-500 mb-10" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-ink-900 transition-colors">Start</Link>
          <span>›</span>
          <span className={label[tone]}>{eyebrow}</span>
        </nav>

        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="font-mono-fine text-[11px] tracking-[0.28em] uppercase text-ink-500">§ {chapter}</span>
              <span className={`h-[1px] w-10 ${dash[tone]}`} />
              <span className={`font-mono-fine text-[11px] tracking-[0.28em] uppercase ${label[tone]}`}>{eyebrow}</span>
            </div>
            <h1 className="font-display font-light text-[3rem] sm:text-[4rem] lg:text-[5.25rem] leading-[0.96] tracking-[-0.035em] text-ink-900">
              {title}
              {italic && (
                <>
                  <br />
                  <span className="italic font-normal">{italic}</span>
                </>
              )}
            </h1>
            {intro && (
              <p className="mt-8 text-ink-700 text-[17px] leading-relaxed max-w-xl">{intro}</p>
            )}
            <div className="mt-10 flex items-center gap-4">
              <Link
                to="/kontakt"
                className="group inline-flex items-center gap-3 pl-6 pr-2 h-14 rounded-full bg-sage-500 hover:bg-sage-600 text-bone-50 text-[14px] tracking-wide transition-all duration-300 hover:-translate-y-0.5"
              >
                Kostenloses Erstgespräch
                <span className="w-11 h-11 rounded-full bg-honey-400 text-ink-900 flex items-center justify-center transition-transform duration-500 group-hover:rotate-45">
                  <ArrowUpRight strokeWidth={1.75} className="w-4 h-4" />
                </span>
              </Link>
            </div>
          </div>

          {image && (
            <div className="lg:col-span-5">
              <div className="relative">
                <div className="absolute -inset-4 bg-bone-200 rounded-[2.5rem] rotate-2" />
                <img
                  src={image}
                  alt={title}
                  style={{ objectPosition: imagePosition === "top" ? "center top" : "center" }}
                  className="relative rounded-[2rem] w-full h-[420px] object-cover shadow-lift"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
